var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { attrs: { viewBox: "0 0 20 16", xmlns: "http://www.w3.org/2000/svg" } },
    [
      _c("path", {
        attrs: {
          d:
            "M6.625 6.582c0-.321.253-.584.563-.584h5.062V2.575c0-.259.302-.39.478-.208l4.978 5.217a.598.598 0 0 1 0 .828l-4.978 5.217c-.176.182-.478.055-.478-.208V9.998H7.187a.575.575 0 0 1-.562-.583V6.582zm-1.125 0v2.833c0 .966.756 1.75 1.688 1.75h3.937v2.256c0 1.295 1.512 1.95 2.398 1.032l4.981-5.213c.661-.686.661-1.794 0-2.48l-4.981-5.217c-.883-.915-2.398-.266-2.398 1.032v2.257H7.187c-.931 0-1.687.787-1.687 1.75zM1 2.75v10.5c0 .966.756 1.75 1.688 1.75h4.64a.431.431 0 0 0 .422-.438v-.291c0-.24-.19-.438-.422-.438h-4.64a.575.575 0 0 1-.563-.583V2.75c0-.32.253-.583.563-.583h4.64a.431.431 0 0 0 .422-.438v-.292c0-.24-.19-.437-.422-.437h-4.64C1.756 1 1 1.784 1 2.75z",
          fill: "#EE4848",
          "fill-rule": "nonzero",
          stroke: "#EE4848",
          "stroke-width": ".2"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }